<template>
  <main id="main">
    <template v-if="$page">
      <SectionsRenderer :sections="$page.sections" />
    </template>
    <Transition name="fade">
      <Loader v-if="!$page" />
    </Transition>
  </main>
</template>

<script>
import SectionsRenderer from '@/components/SectionsRenderer.vue'
import { Loader } from '@/components/small'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Home',
  mixins: [PageMetaMixin],
  beetPage: 'home',
  components: {
    Loader,
    SectionsRenderer,
  },
}
</script>
